




import type { PropType } from '@nuxtjs/composition-api';
// eslint-disable-next-line no-duplicate-imports
import { defineComponent } from '@nuxtjs/composition-api';

import { useNostoProduct } from '~/diptyqueTheme/composable/nosto/useNostoProduct';
import { useNostoStore } from '~/diptyqueTheme/stores/nosto';

export default defineComponent({
  name: 'NostoProduct',
  props: {
    productId: {
      type: String as PropType<string>,
      required: true
    },
    productRef: {
      type: [String, null] as PropType<string | null>,
      default: null
    }
  },
  setup(props) {
    const { setProductId } = useNostoStore();
    useNostoProduct(props.productId, props.productRef);
    setProductId(props.productId);
  }
});
